import React, { useState, useMemo } from "react";
import { Row, Col } from "antd";
import {
  CheckOutlined,
  DoubleRightOutlined,
  EyeOutlined,
  PhoneOutlined,
  UserOutlined,
} from "@ant-design/icons";
import FilterSection from "./FilterSection";
import HotelCard from "./HotelCard";
import tourDetails from "../assets/images/tourDetails.webp";
import holidayImg from "../assets/images/tourDetails.webp";
import SortOptions from "./SortOptions";
import HolidayCard from "./HolidayCard";

const HolidayCardCategory = () => {
  // Example hotel data
  const sampleHotel = [
    {
      id: 1,
      title: "Amazing Dubai with Indian Meal Special - Seal Deal",
      subtitle: "Seal Deal with Flights & Meals",
      duration: "5N/6D",
      features: [
        "Round Trip Flights",
        "4 Star Hotel",
        "Airport Transfers",
        "15 Activities",
        "Visa",
        "Selected Meals",
      ],
      hotelOptions: "Ramada by Wyndham Abu Dhabi Corniche or similar",
      tourOptions: "Arrival & NBA Abu Dhabi Game Night, Departure",
      oldPrice: "2,65,185",
      price: "1,43,200",
      taxes: "7,650",
      reviews: 523,
      images: [holidayImg, holidayImg, holidayImg, holidayImg],
    },
    {
      id: 2,
      title: "Amazing Dubai with Indian Meal Special - Seal Deal",
      subtitle: "Seal Deal with Flights & Meals",
      duration: "5N/6D",
      features: [
        "Round Trip Flights",
        "4 Star Hotel",
        "Airport Transfers",
        "15 Activities",
        "Visa",
        "Selected Meals",
      ],
      hotelOptions: "Ramada by Wyndham Abu Dhabi Corniche or similar",
      tourOptions: "Arrival & NBA Abu Dhabi Game Night, Departure",
      oldPrice: "2,65,185",
      price: "1,43,200",
      taxes: "7,650",
      reviews: 523,
      images: [
        "https://images.unsplash.com/photo-1507525428034-b723cf961d3e",
        "https://images.unsplash.com/photo-1506744038136-46273834b3fb",
        "https://images.unsplash.com/photo-1493558103817-58b2924bce98",
        "https://images.unsplash.com/photo-1526772662000-3f88f10405ff",
      ],
    },
    {
      id: 3,
      title: "Amazing Dubai with Indian Meal Special - Seal Deal",
      subtitle: "Seal Deal with Flights & Meals",
      duration: "5N/6D",
      features: [
        "Round Trip Flights",
        "4 Star Hotel",
        "Airport Transfers",
        "15 Activities",
        "Visa",
        "Selected Meals",
      ],
      hotelOptions: "Ramada by Wyndham Abu Dhabi Corniche or similar",
      tourOptions: "Arrival & NBA Abu Dhabi Game Night, Departure",
      oldPrice: "2,65,185",
      price: "1,43,200",
      taxes: "7,650",
      reviews: 523,
      images: [
        "https://images.unsplash.com/photo-1507525428034-b723cf961d3e",
        "https://images.unsplash.com/photo-1506744038136-46273834b3fb",
        "https://images.unsplash.com/photo-1493558103817-58b2924bce98",
        "https://images.unsplash.com/photo-1526772662000-3f88f10405ff",
      ],
    },
  ];

  // Filter state
  const [selectedFilters, setSelectedFilters] = useState({
    cities: [],
    priceRange: [0, Infinity],
    stars: [],
    ratings: [],
    propertyTypes: [],
  });

  // Filter logic
  const filteredHotels = useMemo(() => {
    return sampleHotel.filter((hotel) => {
      const { cities, priceRange, stars, ratings, propertyTypes } =
        selectedFilters;

      const priceValue = parseInt(hotel.price.replace(/[^\d]/g, "")); // convert "INR 9,000" to 9000

      // City filter
      if (cities.length && !cities.includes(hotel.city)) return false;

      // Price range filter
      if (priceValue < priceRange[0] || priceValue > priceRange[1])
        return false;

      // Star filter
      if (stars.length && !stars.includes(hotel.star)) return false;

      // Rating filter
      if (ratings.length && !ratings.some((r) => hotel.rating >= r))
        return false;

      // Property type filter
      if (propertyTypes.length && !propertyTypes.includes(hotel.type))
        return false;

      return true;
    });
  }, [sampleHotel, selectedFilters]);

  return (
    <div className="container">
      <div className="flex justify-between align-middle items-center text-xl mb-4">
        <h2 className="font-medium text-danger">
          <span className="text-primary">2659 Properties in </span> Goa
        </h2>
      </div>
      <SortOptions />
      <h2 className="text-sm font-medium mb-4">
        {filteredHotels.length} Hotels Found{" "}
        <span className="text-danger">({sampleHotel.length} Total)</span>
      </h2>

      <div className="flex gap-6">
        {/* Hotels List */}
        <div className="flex-1 border border-[#CCE1F9] p-4">
          <Row gutter={[16, 16]}>
            {filteredHotels.map((hotel) => (
              <Col xs={24} key={hotel.id}>
                <HolidayCard hotel={hotel} />
              </Col>
            ))}
            {filteredHotels.length === 0 && (
              <div className="text-center w-full text-gray-500 py-10">
                No sampleHotel match your filters.
              </div>
            )}
          </Row>
        </div>

        {/* Sidebar Filters */}
        <FilterSection
          selectedFilters={selectedFilters}
          setSelectedFilters={setSelectedFilters}
        />
      </div>
    </div>
  );
};

export default HolidayCardCategory;
